export default "__VITE_ASSET__D7Ui5RTs__"